import APIKit from "../Allapis/Apikit/apikit";

export const getAllCPs = async (id, body) => {
  let result;
  try {
    const url = `/cps/getconnectors`;
    if (id) result = await APIKit.post(url, { id });
    else result = await APIKit.post(url, body);
    return result?.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const updateConnector = async (id, body) => {
  let result;
  try {
    const url = `/cps/update/${id}`;
    result = await APIKit.put(url, body);
    return result?.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
